import {OnInit, Component, Input, Output, EventEmitter} from '@angular/core';
import {Router} from '@angular/router';
import {EditPlaylistComponent} from '../edit-playlist/edit-playlist.component';
import {PlaylistService, AuthService} from '../../api/';
import {Helper} from '../../helper';
import {Globals} from '../../app.globals';
import {MdDialog, MdDialogRef} from '@angular/material';
import {PlayerService} from '../../player/services/player.service';

@Component({
    selector: 'app-grid-view-playlists',
    templateUrl: './grid-view-playlists.component.html',
    styleUrls: ['./grid-view-playlists.component.css']
})
export class GridViewPlaylistsComponent implements OnInit {
    @Input() playlist: any;
    @Output() playListDeleted: EventEmitter<any> = new EventEmitter();
    @Output() refreshPlaylist: EventEmitter<any> = new EventEmitter();
    @Output() itemRemoved: EventEmitter<any> = new EventEmitter();
    @Input() clickAble: boolean = true;
    private helper = new Helper();
    private radioUrl = new Globals().radioEndpoint;
    private playlistDesc: string = '';
    private playlistName: string = '';
    private playlistCreatedBy: string = '';
    checkDevice: boolean = false;
    dialogRef: MdDialogRef<EditPlaylistComponent>;
    // to disable the button for Radio Playlist
    disableButtonForRadio:boolean = false;
    
    constructor(public authService: AuthService, private router: Router, private playlistService: PlaylistService, public dialog: MdDialog, public playerService: PlayerService) {
    }

    ngOnInit() {
        // check the count to disable the action buttons for radio
        let songsCount: number = parseInt(localStorage.getItem("listenCount"));
        if (songsCount>= 5 && this.playlist.type == 'R') {
            this.disableButtonForRadio = true;
        } else {
            this.disableButtonForRadio = false;
        }
        this.checkDevice = false;
        if (screen.width <= 1034) {
            this.checkDevice = true;
        }
        this.playlist.radioUrl = this.radioUrl + this.playlist.slug + '.ogg';
        if(this.playlist) {
            if (this.playlist.name && this.playlist.name != null && this.playlist.name.length > 28) {
                this.playlistName = this.playlist.name.slice(0, 28);
            }
            if (this.playlist.created_by && this.playlist.created_by != null && this.playlist.created_by.length > 28) {
                this.playlistCreatedBy = this.playlist.created_by.slice(0, 28);
            }
        }
    }


    emit(event) {
        this.playListDeleted.emit(event);
    }

    editPlaylist(event) {
        event.stopPropagation();
        event.preventDefault();
        this.dialogRef = this.dialog.open(EditPlaylistComponent, {
            disableClose: false,
            width: '800px'
        });
        this.dialogRef.componentInstance.playlist = this.playlist;
        this.dialogRef.afterClosed().subscribe(result => {
            this.refreshPlaylist.emit({refresh: 1});
            this.dialogRef = null;
        });

    }

    navigateToPlaylist() {
        let link = this.helper.setLink(this.playlist);
        if (this.playlist.type !== 'R' && this.clickAble === true) {
            this.router.navigate([link]);
        }
    }

    itemRemove(event) {
        this.itemRemoved.emit({id: event.removed});
    }
    
}



// WEBPACK FOOTER //
// ./src/app/playlists/grid-view-playlists/grid-view-playlists.component.ts